import React from 'react';
import ReactSpeedometer from 'react-d3-speedometer';
import { useTheme } from '@material-ui/core';

//TODO: why is value typeof a string?

const BreachRiskMeter = (props) => {
  const theme = useTheme();
  const {
    currentValueText = 'Risk',
      width = 140,
      height = 140,
      value = 0,
    valueTextFontSize = '16px',
      hideNeedle = false,
      segmentTextFontSize = '12px',
      ringWidth = 40,
      needleHeightRatio = 0.75,
      fluidWidth = false,
      forceRender = false,
  } = props;
  return (
    <ReactSpeedometer
        forceRender={forceRender}
      value={value ? value : 0}
      minValue={0}
      maxValue={10}
      width={width}
      height={height}
      customSegmentLabels={[
        {
          text: "Lowest",
          position: "OUTSIDE",
          fontSize: segmentTextFontSize,
        },
        {
          text: "Low",
          position: "OUTSIDE",
          fontSize: segmentTextFontSize,
        },
        {
          text: "Medium",
          position: "OUTSIDE",
          fontSize: segmentTextFontSize,
        },
        {
          text: "High",
          position: "OUTSIDE",
          fontSize: segmentTextFontSize,
        },
        {
          text: "Highest",
          position: "OUTSIDE",
          fontSize: segmentTextFontSize,
        },
      ]}
      ringWidth={ringWidth}
      needleColor={theme.palette.text.secondary}
      needleHeightRatio={hideNeedle ? 0.05 : needleHeightRatio}
      needleTransitionDuration={1200}
      needleTransition="easeSinInOut"
      segmentColors={['#00863B', '#5FBA15', '#EDEA34', '#F28722', '#F6101F']}
      currentValueText= {currentValueText} //{'${value}s User online'}
      valueTextFontSize={valueTextFontSize}
      textColor={theme.palette.text.primary}
      fluidWidth = {fluidWidth}
    />
  );
};

export default BreachRiskMeter;
